require('./bootstrap');
window.Vue = require('vue');
window.moment = require('moment');
require('vue-resource');
Vue.http.interceptors.push((request, next) => {
  request.headers.set('X-CSRF-TOKEN', Laravel.csrfToken);
  next();
});
import Datepicker from 'vuejs-datepicker';
import vSelect from 'vue-select';
import { VTooltip, VPopover } from 'v-tooltip';
import localization from 'moment/locale/nl';
import autocomplete from 'vuejs-auto-complete';
import Notifications from 'vue-notification';
import { Sortable, MultiDrag } from 'sortablejs';
import VueSweetalert2 from 'vue-sweetalert2';
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";
import { CaptureConsole as CaptureConsoleIntegration } from "@sentry/integrations";
Vue.use(Notifications);
Vue.use(VueSweetalert2);
window.Sortable = Sortable;
window.Sortable.mount(new MultiDrag());
window.moment.updateLocale('nl', localization);
Vue.prototype.$moment = window.moment;
if (process.env.MIX_SENTRY_VUE_DSN) {
  // Sentry.init({
  //     Vue,
  //     dsn: `${process.env.MIX_SENTRY_VUE_DSN}`,
  //     environment: `${process.env.MIX_SENTRY_ENVIRONMENT}`,
  //     release: `${process.env.MIX_SENTRY_RELEASE}`,
  //     tracesSampleRate: process.env.MIX_SENTRY_TRACES_SAMPLE_RATE ? parseFloat(process.env.MIX_SENTRY_TRACES_SAMPLE_RATE) : 1,
  //     integrations: [
  //         new BrowserTracing({
  //             tracePropagationTargets: ["platform.auto.test", "programic.dev", /^\//],
  //         }),
  //         new CaptureConsoleIntegration({
  //             // array of methods that should be captured
  //             // defaults to ['log', 'info', 'warn', 'error', 'debug', 'assert']
  //             levels: ['error'],
  //         }),
  //     ],
  // });
}
window.Vue.component('job-comment-list', require('./components/Job/Comments/Index.vue'));
window.Vue.component('ride-comment-form', require('./components/Job/Comments/Form.vue'));
window.Vue.component('vue-pagination', require('./components/Pagination.vue'));
window.Vue.component('uploader', require('./components/Uploader.vue'));
window.Vue.component('modal', require('./components/Modal.vue'));
window.Vue.component('textarea-counter', require('./components/TextareaCounter.vue'));
window.Vue.component('sms-modal', require('./components/drivers/SmsModal.vue'));
window.Vue.component('document-modal', require('./components/documents/DocumentModal.vue'));
window.Vue.component('planscreen', require('./components/plan/Planscreen.vue'));
window.Vue.component('plan-group-rides', require('./components/plan/JobGroup.vue'));
window.Vue.component('document-edit', require('./components/documents/DocumentEdit.vue'));
window.Vue.component('document-list', require('./components/documents/DocumentList.vue'));
window.Vue.component('range-date', require('./components/RangeDate.vue'));
window.Vue.component('app-card', require('./components/AppCard.vue'));
window.Vue.component('app-button-group', require('./components/AppButtonGroup.vue'));
window.Vue.component('app-datepicker', require('./components/AppDatepicker.vue'));
window.Vue.component('app-multiselect', require('./components/AppMultiselect.vue'));
window.Vue.component('app-adressbook-modal', require('./components/AppAddressBookModal.vue'));
window.Vue.component('availability-multiselect', require('./components/drivers/AvailabilityMultiSelect.vue'));
window.Vue.component('driver-availability-multiselect', require('./components/drivers/DriverAvailabilityMultiSelect.vue'));
window.Vue.component('app-datatable', require('./components/AppDatatable.vue'));
window.Vue.component('app-dropzone', require('./components/AppDropzone.vue'));
window.Vue.component('app-toggle', require('./components/AppToggle.vue'));
window.Vue.component('v-draggable', require('vuedraggable'));
window.Vue.component('datepicker', Datepicker);
window.Vue.component('v-select', vSelect);
window.Vue.directive('tooltip', VTooltip);
window.Vue.component('v-popover', VPopover);
window.Vue.component('autocomplete', autocomplete);
window.Vue.component('notification', require('./components/Notify.vue'));
window.Vue.component('tiny-editor', require('./components/TinyEditor.vue'));
window.Vue.component('passport-clients', require('./components/passport/Clients.vue'));
window.Vue.component('passport-authorized-clients', require('./components/passport/AuthorizedClients.vue'));
window.Vue.component('passport-personal-access-tokens', require('./components/passport/PersonalAccessTokens.vue'));
window.Vue.filter('formatDate', value => {
  if (value) {
    return moment(String(value)).format('DD-MM-YYYY HH:mm');
  }
});
window.Vue.filter('formatTime', value => {
  if (value) {
    return moment(String(value), 'HH:mm:ss').format('HH:mm');
  }
});
window.Vue.filter('nl2br', str => {
  if (typeof str === 'undefined' || str === null) {
    return '';
  }
  const breakTag = '<br>';
  return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
});
window.Vue.filter('highlight', (words, query) => {
  if (query.length < 1) {
    return words;
  }
  const queryEscaped = query.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  const regex = new RegExp(queryEscaped, 'gi');
  return words.replace(regex, str => {
    return `<span class="text-highlight">${str}</span>`;
  });
});

// jQuery
(function () {
  $(function () {
    $('[data-toggle="tooltip"]').tooltip();
  });
  $(document).on('click', '[data-toggleclass]', function (e) {
    e.preventDefault();
    $($(this).data('target')).toggleClass($(this).data('toggleclass'));
  });
})();
navigator.permissions.query({
  name: 'clipboard-write'
}).then(() => {
  document.addEventListener('click', e => {
    if (Object.keys(e.target.dataset).includes('copyClick')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      navigator.clipboard.writeText(e.target.innerText).then(() => {
        e.target.classList.add('copied');
        setTimeout(() => {
          e.target.classList.remove('copied');
        }, 500);
      }, () => {
        // error
      });
    }
  }, {
    capture: true
  });
});
window.errorHandler = message => {
  window.notify({
    clean: true
  });
  window.notify({
    title: `Er is een fout opgetreden`,
    text: `Werkt een functionaliteit niet zoals gewenst? Herlaad de pagina.`,
    type: 'error',
    duration: -1
  });
};

// Vue.config.errorHandler = function(message, vm, info) {
//     // window.errorHandler(message);
//
//     console.error(message);
// };
//
// window.onerror = function(message, source, lineno, colno, error) {
//     // window.errorHandler(message);
//     console.error(message);
// };

const app = new Vue().$mount('#app');


// WEBPACK FOOTER //
// ./resources/js/app.js